import React, { useState, useContext, useEffect } from 'react';
import { Container, Table, Spinner, Form, Row, Col, InputGroup, Button, Accordion } from 'react-bootstrap';
import { AppContext } from '../App';


export const CustomerReport = () => {
	const { getCustomerReportLoad, customerReport, getDate, getCustomerReport, getBill, setViewBillModal } = useContext(AppContext);
	const [searchResult, setSearchResult] = useState([]);
	const [searchPageCount, setSearchPageCount] = useState(0);
	const [currentSearchPage, setCurrentSearchPage] = useState(0);
	const [searchTerm, setSearchTerm] = useState("");
	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		if (start !== "" && end !== "") {
			getCustomerReport(start, end);
		}
	}
	const search = (s_name) => {
		if (s_name !== "") {
			if (customerReport !== undefined && Object.keys(customerReport).length > 0) {
				const results = [];
				let count = 0;
				for (const cred in customerReport) {
					if (count >= 250) break;
					if (customerReport[cred].customer_name.toLowerCase().includes(s_name.toLowerCase()) || customerReport[cred].customer_phone.includes(s_name)) {
						results.push(cred);
						count += 1;
					}
				}
				setSearchResult(results);
			} else {
				setSearchResult(Object.keys(customerReport));
			}
		} else {
			setSearchResult(Object.keys(customerReport));
		}
	}

	useEffect(() => {
		if (searchResult !== undefined) {
			setCurrentSearchPage(0);
			let len = Object.keys(searchResult).length;
			setSearchPageCount(Math.ceil(len / 10));
		}
	}, [searchResult]);

	useEffect(() => {
		if (customerReport !== undefined) {
			if (searchResult.length === 0) {
				setCurrentSearchPage(0);
				setSearchResult(Object.keys(customerReport));
				setSearchPageCount(Math.ceil(Object.keys(customerReport).length / 10));
			}
			if (searchTerm !== "") {
				search(searchTerm);
			}
		}
	}, [customerReport]);

	return (
		<div className='container-fluid'>
			<div className='grid4by6 align-items-center justify-content-between bgp p-2 br-3 mb-2'>
				{
					getCustomerReportLoad ? (
						<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
					) : (
						<span className='text-white' >Customer wise invoice report</span>
					)
				}
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			<Form onSubmit={(e) => { e.preventDefault() }} className='mb-3' >
				<InputGroup>
					<Form.Control
						value={searchTerm}
						onChange={(e) => {
							const value = e.target.value;
							setSearchTerm(value);
							search(value);
						}}
						id="credit_search_box"
						className="br-2"
						size="lg"
						type="text"
						placeholder="Search here by number or name"
					/>
					<InputGroup.Text className="br-3 btn-t1 px-4" id="basic-addon2"><i className="bi bi-search"></i></InputGroup.Text>
				</InputGroup>
			</Form>
			{

				customerReport !== undefined ? (
					Object.keys(customerReport).length > 0 ? (
						searchResult !== undefined && searchResult.length > 0 ? (
							<>
								{
									searchResult.map((cus, cus_i) => (
										searchPageCount !== undefined && cus_i >= currentSearchPage && cus_i < currentSearchPage + 10 ? (
											<Accordion key={`custo_${cus_i}`} className="mb-2" >
												<Accordion.Item eventKey="0">
													<Accordion.Header><span className="tp1 f18" >{customerReport[cus].customer_name}, {customerReport[cus].customer_phone}</span></Accordion.Header>
													<Accordion.Body>
														<Table bordered className="tbl-bg-blue" >
															<thead>
																<tr>
																	<th><span className="tp2" >Date</span></th>
																	<th><span className="tp2" >Time</span></th>
																	<th><span className="tp2" >Invoice</span></th>
																	<th className="text-end tp2" ><span>SC</span></th>
																	<th className="text-end tp2" ><span>OC</span></th>
																	<th className="text-end tp2" ><span>Credit</span></th>
																	<th className="text-end tp2" >Total</th>
																</tr>
															</thead>
															<tbody>
																{
																	customerReport[cus].bills !== undefined ? (
																		Object.keys(customerReport[cus].bills).length > 0 ? (
																			Object.keys(customerReport[cus].bills).map((bill, bill_i) => (
																				<tr key={`bill_${bill_i}`}>
																					<td><span className="tp2">{customerReport[cus].bills[bill].bill_date} <span onClick={() => {
																						getBill(customerReport[cus].bills[bill].bill_id);
																						setViewBillModal(true);
																					}} className="view-bill-link" >View bill</span></span></td>
																					<td><span className="tp2">{customerReport[cus].bills[bill].bill_time}</span></td>
																					<td><span className="tp2">{customerReport[cus].bills[bill].bill_id}</span></td>
																					<td className="tp2 text-end"><span>{parseFloat(customerReport[cus].bills[bill].service_amount_total).toFixed(2)}</span></td>
																					<td className="tp2 text-end"><span>{parseFloat(customerReport[cus].bills[bill].transaction_total).toFixed(2)}</span></td>
																					<td className="tp2 text-end">
																						{
																							customerReport[cus].bills[bill].credit_amount !== null && customerReport[cus].bills[bill].credit_amount !== "" && customerReport[cus].bills[bill].credit_amount > 0 ? (
																								customerReport[cus].bills[bill].credit_status ? (
																									<span className="sucess-tag mx-2"><i className="bi bi-check-circle"></i> Paid</span>
																								) : (

																									<span className="error-message mx-2"><i className="bi bi-x-circle"></i> Pending</span>
																								)
																							) : ''
																						}
																						<span>{parseFloat(customerReport[cus].bills[bill].credit_amount).toFixed(2)}</span>
																					</td>
																					<td className="tp2 text-end"><span>{parseFloat(customerReport[cus].bills[bill].bill_total).toFixed(2)}</span></td>
																				</tr>
																			))
																		) : ''
																	) : ''
																}
																<tr>
																	<td colSpan={3} className="text-end bgy"><span className="f20" >Total</span></td>
																	<td className="text-end bgy" ><span className='f20' >{parseFloat(customerReport[cus].serv_bills_total).toFixed(2)}</span></td>
																	<td className="text-end bgy" ><span className='f20' >{parseFloat(customerReport[cus].trans_bills_total).toFixed(2)}</span></td>
																	<td className="text-end bgy" ><span className='f20' >{parseFloat(customerReport[cus].credit_bills_total).toFixed(2)}</span></td>
																	<td className="text-end bgy" ><span className='f20' >{parseFloat(customerReport[cus].bills_total).toFixed(2)}</span></td>
																</tr>
															</tbody>
														</Table>
													</Accordion.Body>
												</Accordion.Item>
											</Accordion>
										) : ''
									))
								}
								<div className="py-2 pagination-wrap" >
									{
										searchPageCount > 0 && (
											<>
												{/* First Page Button */}
												<div
													onClick={() => { setCurrentSearchPage(0) }}
													className={currentSearchPage === 0 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === 0 ? 0.5 : 1, cursor: currentSearchPage === 0 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-double-left"></i></span>
												</div>

												{/* Previous 6 Pages Button */}
												<div
													onClick={() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const newPageIndex = Math.max(0, currentPageIndex - 6);
														setCurrentSearchPage(newPageIndex * 10);
													}}
													className={currentSearchPage === 0 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === 0 ? 0.5 : 1, cursor: currentSearchPage === 0 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-left"></i></span>
												</div>

												{/* Page Numbers (Max 6 visible) */}
												{
													(() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const startPage = Math.floor(currentPageIndex / 6) * 6;
														const endPage = Math.min(startPage + 6, searchPageCount);

														return Array.from({ length: endPage - startPage }, (_, i) => {
															const pageIndex = startPage + i;
															return (
																<div
																	key={`search-page-${pageIndex}`}
																	onClick={() => { setCurrentSearchPage(pageIndex * 10) }}
																	className={currentSearchPage === pageIndex * 10 ? 'pageination-index m-2 active' : 'pageination-index m-2'}
																>
																	<span>{pageIndex + 1}</span>
																</div>
															);
														});
													})()
												}

												{/* Next 6 Pages Button */}
												<div
													onClick={() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const newPageIndex = Math.min(searchPageCount - 1, currentPageIndex + 6);
														setCurrentSearchPage(newPageIndex * 10);
													}}
													className={currentSearchPage === (searchPageCount - 1) * 10 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === (searchPageCount - 1) * 10 ? 0.5 : 1, cursor: currentSearchPage === (searchPageCount - 1) * 10 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-right"></i></span>
												</div>

												{/* Last Page Button */}
												<div
													onClick={() => { setCurrentSearchPage((searchPageCount - 1) * 10) }}
													className={currentSearchPage === (searchPageCount - 1) * 10 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === (searchPageCount - 1) * 10 ? 0.5 : 1, cursor: currentSearchPage === (searchPageCount - 1) * 10 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-double-right"></i></span>
												</div>
											</>
										)
									}
								</div>
							</>
						) : (
							<span>Search result not found!</span>
						)
					) : 'Not found!'
				) : ''

			}
		</div>
	)
}